import React, { useEffect, useState } from "react";
import "../noreba.css";

function Actas() {
    const [lista, setLista] = useState([]);
    const [error, setError] = useState("");

    useEffect(() => {
        fetch("/api/actas")
            .then((r) => r.json())
            .then(setLista)
            .catch(() => setError("No se pudieron cargar los documentos"));
    }, []);

    const formatFecha = (v) => {
        if (!v) return "";
        const d = new Date(v);
        return isNaN(d) ? v : d.toLocaleDateString("es-ES");
    };

    const descargar = async (item) => {
        try {
            const r = await fetch(`/api/actas/${item._id}?download=1`);
            if (!r.ok) throw new Error("Error al descargar el archivo");
            const blob = await r.blob();
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            // ✅ Prioridad: metadata.nombre > nombre > alias > filename
            a.download = (item.metadata?.nombre || item.nombre || item.alias || item.filename || "actas") + ".pdf";
            a.click();
            a.remove();
        } catch {
            setError("No se pudo descargar el archivo");
        }
    };

    return (
        <div className="noreba-wrap">
            <header className="noreba-header"><h1>Actas</h1></header>

            {error && <div className="noreba-error">{error}</div>}

            <section className="noreba-list">
                {lista.length === 0 && (
                    <div className="noreba-empty">No hay documentos</div>
                )}

                {lista.map((it) => (
                    <article key={it._id} className="noreba-item">
                        <div className="info">
                            {/* ✅ mostramos metadata.nombre como principal */}
                            <div className="title">
                                {it.metadata?.nombre || it.nombre || it.alias || it.filename}
                            </div>
                            <div className="meta">
                                {/* ✅ mostramos metadata.fecha si existe */}
                                <span>{(it.length / 1024).toFixed(1)} KB</span> •{" "}
                                <span>{formatFecha(it.metadata?.fecha || it.fecha || it.uploadDate)}</span>
                            </div>
                        </div>
                        <div className="actions">
                            <button className="btn-view" onClick={() => descargar(it)}>
                                Descargar
                            </button>
                        </div>
                    </article>
                ))}
            </section>
        </div>
    );
}

export default Actas;
